import { useEffect, useRef, useState, useSyncExternalStore } from "react";
import { Link } from "react-router-dom";
import { getAdConsent, setAdConsent, subscribeAdConsent, type AdConsent } from "../lib/google-ads";

export function AdConsentBanner() {
  const consent = useSyncExternalStore(subscribeAdConsent, getAdConsent, () => null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const heading = useRef<HTMLHeadingElement>(null);
  const returnFocus = useRef<HTMLElement | null>(null);
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    const notice = document.querySelector(".ticket-disclosure");
    if (!notice) return;
    const root = document.documentElement;
    const measure = () => root.style.setProperty("--ticket-disclosure-height", `${Math.ceil(notice.getBoundingClientRect().height)}px`);
    measure();
    const observer = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(measure);
    observer?.observe(notice);
    return () => {
      observer?.disconnect();
      root.style.removeProperty("--ticket-disclosure-height");
    };
  }, []);

  useEffect(() => {
    const open = () => {
      returnFocus.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      setSettingsOpen(true);
    };
    window.addEventListener("rp-open-cookie-settings", open);
    return () => window.removeEventListener("rp-open-cookie-settings", open);
  }, []);

  useEffect(() => {
    if (settingsOpen) heading.current?.focus({ preventScroll: true });
  }, [settingsOpen]);

  const choose = (choice: AdConsent) => {
    const reload = setAdConsent(choice);
    setSettingsOpen(false);
    setAnnouncement(choice === "accepted" ? "Analytics and advertising measurement accepted." : choice === "analytics-only" ? "Analytics measurement accepted; advertising measurement rejected." : "Analytics and advertising measurement rejected.");
    returnFocus.current?.focus({ preventScroll: true });
    if (reload) window.location.reload();
  };

  return (
    <>
      <span className="sr-only" role="status">{announcement}</span>
      {consent === null || settingsOpen ? (
        <aside className="ad-consent-banner" aria-labelledby="ad-consent-title">
          <h2 id="ad-consent-title" ref={heading} tabIndex={-1}>Cookie choices</h2>
          <p>Google Analytics measures visits and WhatsApp clicks; Google Ads measures campaign results. No message contents or customer contact details are sent. Personalised advertising is off. A click is not a confirmed enquiry.</p>
          <p>Optional: enquiries work without these cookies. <Link to="/privacy">Privacy policy</Link> · Change later via footer Cookie settings.</p>
          <div className="ad-consent-actions">
            <button className="button button-secondary" type="button" onClick={() => choose("rejected")}>Reject all</button>
            <button className="button button-secondary" type="button" onClick={() => choose("analytics-only")}>Analytics only</button>
            <button className="button button-secondary" type="button" onClick={() => choose("accepted")}>Accept all</button>
          </div>
        </aside>
      ) : null}
    </>
  );
}
